import { render } from "./Column202308.vue?vue&type=template&id=7982aa18&scoped=true"
import script from "./Column202308.vue?vue&type=script&lang=js"
export * from "./Column202308.vue?vue&type=script&lang=js"

import "./Column202308.vue?vue&type=style&index=0&id=7982aa18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7982aa18"

export default script